import { ACTIVE_SUBSCRIPTION_TYPES } from "@arbeidsark/shared"
import { useNavigate } from "react-router-dom"
import { useOrganizationMembership } from "../../../utils/hooks/useOrganizationMembership"
import { useSubscriptionInfo } from "../../../utils/hooks/useSubscriptionInfo"
import BuyNewSubscription from "./BuyNewSubscription"

export type BuyNewSubscriptionWrapperProps = {}

const BuyNewSubscriptionWrapper: React.FC<
  BuyNewSubscriptionWrapperProps
> = () => {
  const subscription = useSubscriptionInfo()
  const navigate = useNavigate()
  const organizationMembership = useOrganizationMembership()

  if (
    (subscription && ACTIVE_SUBSCRIPTION_TYPES.includes(subscription.status)) ||
    organizationMembership
  ) {
    navigate("/home")
    return null
  }

  return <BuyNewSubscription />
}

export default BuyNewSubscriptionWrapper
